import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

export default function SavingPage() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div
      className="min-h-screen overflow-auto bg-[#000000] mt-[70px]"
      style={{
        backgroundImage:
          'url("https://api.demo92.apptestlive.com/assets/images/offer-bg.png")',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <HeaderTop title={i18next.t("invite_title")} />
      <div className="flex flex-col text-[#fff] max-w-[1200px] mx-auto px-5">
        <div>
          <div className="pt-[60px] pb-[60px] grid grid-cols-1 lg:grid-cols-2">
            <div className="flex flex-col">
              <h1 className="pb-4 text-[40px] font-extrabold text-[#fff] flex flex-col">
                <span>{i18next.t("note35")}</span>
                <span>{i18next.t("note36")}</span>
              </h1>
              <div className="text-[16px] text-[#fff]">
                {i18next.t("note37")}
              </div>
            </div>
            <div className="hidden lg:block">
              <img
                className="w-full"
                src="https://api.demo92.apptestlive.com/assets/images/banner-offer.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="py-[10px] bg-[#1E2329] pb-10 px-5">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="my-12 text-[32px] text-[#fff]">
            {i18next.t("note38")}
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 text-[#fff] ">
            <div>
              <img
                className="w-full pb-4"
                src="https://api.demo92.apptestlive.com/assets/images/tutorial-step1.png"
                alt=""
              />
              <span className="text-[20px] ">{i18next.t("note39")}</span>
            </div>
            <div>
              <img
                className="w-full pb-4"
                src="https://api.demo92.apptestlive.com/assets/images/tutorial-step2.png"
                alt=""
              />
              <span className="text-[20px] ">{i18next.t("note40")}</span>
            </div>
            <div>
              <img
                className="w-full pb-4"
                src="https://api.demo92.apptestlive.com/assets/images/tutorial-step3.png"
                alt=""
              />
              <span className="text-[20px] ">{i18next.t("note41")}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-6 items-center justify-center bg-[#0b0e11] py-6 lg:py-10 px-4">
        <h2 className="text-[#eaecef] text-2xl lg:text-[32px]">
          {i18next.t("note42")}
        </h2>
        <a
          className="xs:w-full lg:w-[164px] py-[10px] lg:py-[14px] px-4 text-[#181a20] bg-[#fcd535] rounded font-medium text-base text-center"
          href="/m/trade/DOGE/USDT"
        >
          {i18next.t("trade")}
        </a>
      </div>
    </div>
  );
}
